module.exports = __webpack_public_path__ + "images/progress-car.5f1fedbd37751be384047a10bc016397.png";